import { Form } from 'antd';
import * as Component from 'components';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as ClipTrailerComponent from '../components';
import clipTrailerService from '../services/clipTrailerService';

dayjs.extend(utc);

const ClipTrailerDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();

  const clipTrailerComponents = [
    {
      key: 'detail',
      title: 'Detail',
      component: <ClipTrailerComponent.DetailComponent />,
    },
    {
      key: 'poster',
      title: 'Poster',
      component: <ClipTrailerComponent.ThumbnailComponent />,
    },
  ];

  useEffect(() => {
    clipTrailerService.fetchById(Number(id)).then(library => {
      form.setFieldsValue({
        ...library,
        distributions: library.distributions?.map(d => d.content_consumer_name) || [],
        release_date_start: library.release_date_start ? dayjs(library.release_date_start) : null,
        release_date_end: library.release_date_end ? dayjs(library.release_date_end) : null,
      });
    });
  }, [id]);

  return (
    <Component.BasePageComponent>
      <h1>Clip / Trailer</h1>
      <Component.TapComponent components={clipTrailerComponents} />
    </Component.BasePageComponent>
  );
};

export default ClipTrailerDetail;
